import { useEffect } from 'react';

export const useResizeObserver = (element: HTMLElement | null, callback: () => void) => {
	useEffect(() => {
		let resizeObserver: ResizeObserver;
		if (element && typeof ResizeObserver !== 'undefined') {
			resizeObserver = new ResizeObserver(callback);
			resizeObserver.observe(element);
		}

		return () => {
			if (resizeObserver) {
				resizeObserver.disconnect();
			}
		};
	}, [element, callback]);

	return null;
};
